import {
  IChangePasswordByAdminReq,
  IUpdateByAdminRequest,
  ITag,
  ITagReq,
  IChangePasswordByUserReq,
  IEditInfoByUserReq
} from "./../../models/user/index";
import {
  IBasePagingRes,
  IBaseResponseModel
} from "../../models/common/models.type";
import api from "../remote/baseApi";
import ApiEndpoints from "../remote/apiEndpoints";
import { envConfig } from "../../config/env.config";
import {
  IChangeStatusResquest,
  ICreateUserRequest,
  IGetUserReq,
  IGetUsersReq,
  IUpdateByOwnerRequest,
  IUpdatePasswordResquest,
  IUser
} from "../../models/user";

const API_USER = ApiEndpoints.USER;
const baseURL = envConfig.ACCOUNT_ENDPOINT;

const createUser = (
  data: ICreateUserRequest
): Promise<IBaseResponseModel<any>> => {
  return api.post(baseURL, API_USER.CREATE.url, data);
};

const getUsers = (
  data: IGetUsersReq
): Promise<IBaseResponseModel<IBasePagingRes<any>>> => {
  return api.get(baseURL, API_USER.GET_USERS.url, {
    params: data
  });
};

const getSingle = (id: string): Promise<IBaseResponseModel<IUser>> => {
  return api.get(baseURL, `${API_USER.GET_SIGNLE.url}/${id}`);
};

const getUserOrDepartment = (
  request: ITagReq
): Promise<IBasePagingRes<ITag>> => {
  return api.get(baseURL, API_USER.GET_USER_OR_DEPARTMENT.url, {
    params: request
  });
};

const getAllUserOrDepartment = (
  request: ITagReq
): Promise<IBasePagingRes<ITag>> => {
  return api.get(baseURL, API_USER.GET_ALL_USER_OR_DEPARTMENT.url, {
    params: request
  });
};

const getUserOrDepartmentByWorkflowId = (
  request: ITagReq,
  workflowId: string
): Promise<IBasePagingRes<ITag>> => {
  return api.get(baseURL, API_USER.GET_USER_OR_DEPARTMENT_BY_WORKFLOW_ID.url, {
    params: { ...request, BoardId: workflowId }
  });
};
const getUserOrDepartmentByStageId = (
  request: ITagReq,
  stageId: string
): Promise<IBasePagingRes<ITag>> => {
  return api.get(baseURL, API_USER.GET_USER_OR_DEPARTMENT_BY_STAGE_ID.url, {
    params: { ...request, WorkflowId: stageId }
  });
};

const getPageChatUserOrDepartment = (
  request: ITagReq
): Promise<IBasePagingRes<ITag>> => {
  return api.get(baseURL, API_USER.Get_Page_Chat_User_Or_Department.url, {
    params: { ...request }
  });
};

const updateUserByAdmin = (
  data: IUpdateByAdminRequest
): Promise<IBaseResponseModel<any>> => {
  return api.put(baseURL, API_USER.UPDATE_BY_ADMIN.url, data);
};

const updateUser = (
  data: IEditInfoByUserReq
): Promise<IBaseResponseModel<any>> => {
  return api.put(baseURL, API_USER.USER_UPDATE.url, data);
};

const updatePasswordByAdmin = (
  data: IChangePasswordByAdminReq
): Promise<IBaseResponseModel<any>> => {
  return api.put(baseURL, API_USER.UPDATE_PASSWORD_BY_ADMIN.url, data);
};

const updatePasswordByUser = (
  data: IChangePasswordByUserReq
): Promise<IBaseResponseModel<any>> => {
  return api.put(baseURL, API_USER.UPDATE_PASSWORD_BY_USER.url, data);
};

const deleteUser = (id: string): Promise<IBaseResponseModel<IUser>> => {
  return api.delete(baseURL, `${API_USER.DELETE.url}/${id}`);
};

const changeLanguage = (
  language: string
): Promise<IBaseResponseModel<string>> => {
  return api.get(
    baseURL,
    `${API_USER.ChangeLanguage.url}?language=${language}`
  );
};
// const updateByOwner = (
//   data: IUpdateByOwnerRequest
// ): Promise<IBaseResponseModel<any>> => {
//   return api.post(baseURL, API_USER.UPDATE_BY_OWNER.url, data);
// };

// const updateStatusUser = (
//   data: IChangeStatusResquest
// ): Promise<IBaseResponseModel<any>> => {
//   return api.post(baseURL, API_USER.UPDATE_STATUS.url, data);
// };

const UserService = {
  createUser,
  getSingle,
  getUsers,
  updateUserByAdmin,
  updateUser,
  updatePasswordByAdmin,
  updatePasswordByUser,
  getUserOrDepartment,
  getAllUserOrDepartment,
  getUserOrDepartmentByWorkflowId,
  getUserOrDepartmentByStageId,
  deleteUser,
  getPageChatUserOrDepartment,
  changeLanguage
  // updatePassword,
  // updateByOwner,
  // updateStatusUser
};

export default UserService;
